import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';
import Pagination from '../../components/Pagination/Pagination';
import SearchSymbol from '../../components/SearchSymbol/SearchSymbol';
import Toast from '../../components/Toast/Toast';
import { getContasAPagars } from '../../services/ContasAPagarService';
import ContasAPagarRow from './ContasapagarRow';
import NewContasAPagarButton from './NewContasapagarButton';
import ContasAPagarModal from './ContasapagarModal/ContasapagarModal';
import DateFilter from '../../components/DateFilter/DateFilter';


function ContasAPagars() {


    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [search, setSearch] = useState(params.nome || '');
    const [editContasAPagar, setEditContasAPagar] = useState({});
    const [ContasAPagars, setContasAPagars] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(parseInt(new URLSearchParams(location.search).get('page') || '1'));
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [filter, setFilter] = useState({});


    const [debouncedSearch] = useDebounce(search, 500);


    // Later in the useEffect hook
    useEffect(() => {
        const token = localStorage.getItem('token');
        getContasAPagars(debouncedSearch, page, token).then(result => {
            setContasAPagars(result.rows);
            setCount(result.count);
        }).catch(err => {
            console.error(err.response ? err.response.data : err.message);
            setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
        });
    }, [debouncedSearch, page]);


    useEffect(() => {
        function handleLocationChange(location) {
            const newPage = parseInt(new URLSearchParams(location.search).get('page') || '1');
            setPage(newPage);
        }

        handleLocationChange(location); // Initialize with current location

        // Potencialmente, adicionar um listener aqui se necessário para mudanças de localização
        // return () => { removeListener(); };
    }, [location]);


    const onSearchChange = (event) => {
        setSearch(event.target.value);
    };

    function onDateChange(event) {

        setFilter(prevState => ({ ...prevState, startDate: event.target.value.startDate, endDate: event.target.value.endDate }));
        console.log(event.target.value.startDate);
        console.log(event.target.value.endDate);
    }

    const onNewContasAPagarClick = () => {
        setEditContasAPagar({ nome: '', isActive: true });
    };

    const onEditClick = (event) => {
        const id = parseInt(event.target.id.replace('edit', ''));
        setEditContasAPagar(ContasAPagars.find(u => u.id === id));
    };

    const onModalSubmit = () => {
        navigate(0);
    };

    return (
        <React.Fragment>
            <Menu />
            <main className="content">
                {/* Cabeçalho da página */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        {/* <h1 className="h4">ContasAPagars...</h1> */}
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent mb-0">
                                <li className="breadcrumb-item">
                                    <a href="#">
                                        <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                                    </a>
                                </li>
                                {/* <li className="breadcrumb-item"><a href="#">Category</a></li> */}
                                <li className="breadcrumb-item active" aria-current="page">Contas a pagar</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="btn-toolbar mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            <NewContasAPagarButton onClick={onNewContasAPagarClick} />
                        </div>
                        <div className="ms-2 ms-lg-3">
                            {/* Campo para consulta */}

                            <SearchSymbol placeholder="ContasAPagar" onChange={onSearchChange} />

                            <div>
                                <DateFilter onClick={onDateChange} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <h1 className="h4">3 - Pontos - Montar tela..</h1> */}

                <div className="row">
                    <div className="col-12">
                        {/* Corpo da pagina */}
                        {/* INICIO DA TABELA */}
                        <div className="card card-body border-0 shadow table-wrapper table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="border-gray-200">View</th>
                                        <th className="border-gray-200">Código</th>
                                        <th className="border-gray-200">Centro de custos</th>
                                        <th className="border-gray-200">Descrição</th>
                                        <th className="border-gray-200">Observação</th>
                                        <th className="border-gray-200">Parcela</th>
                                        <th className="border-gray-200">Valor</th>
                                        <th className="border-gray-200">Vencimento</th>

                                        <th className="border-gray-200">Ativo</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        ContasAPagars.map(ContasAPagars => (
                                            <ContasAPagarRow key={ContasAPagars.id} data={ContasAPagars} onEditClick={onEditClick} />
                                        ))
                                    }
                                </tbody>
                            </table>
                            <Pagination count={count} />
                        </div>
                        {/* FINAL DA TABELA */}


                    </div>
                </div>
                {/* Rodape da página */}
                <Footer />
            </main>
            <ContasAPagarModal data={editContasAPagar} onSubmit={onModalSubmit} />
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default ContasAPagars;